var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scrollTopHigth > 100)?_c('div',{staticClass:"goTop",on:{"click":_vm.goTop}},[_c('img',{attrs:{"src":require("../../images/totop_arrow.svg"),"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }